import React, { Component } from 'react'

import { Helmet } from 'react-helmet'

import Header from './block/Header'
import Footer from './block/Footer'
import OffcanvasMenu from './block/OffcanvasMenu'
import Window from './block/Window'
import CookieBanner from './block/CookieBanner'
import MobileFooter from './block/MobileFooter'

import Main from './pages/Main'
import Production from './pages/Production'
import Razdel from './pages/Razdel'
import Tovar from './pages/Tovar'
import Docks from './pages/Docks'
import Materiali from './pages/Materiali'
import Material from './pages/Material'
import Kontakti from './pages/Kontakti'
import About from './pages/About'
import Sotrudnichestvo from './pages/Sotrudnichestvo'
import Otosole from './pages/Otosole'
import Page from './pages/Page'

class App extends Component {
  state = {
    showOffcanvas: false,
    showWindow: false
  }

  handleShow = () => {
    this.setState({ showOffcanvas: true })
  }

  handleHide = () => {
    this.setState({ showOffcanvas: false })
  }

  handleShowWindow = () => {
    this.setState({ showWindow: true })
  }

  handleHideWindow = () => {
    this.setState({ showWindow: false })
  }

  // Новый метод для генерации JSON-LD хлебных крошек
  generateBreadcrumbJsonLd() {
    const { data } = this.props;
    const breadcrumbs = data?.breadcrumbs;

    // Проверяем, есть ли данные и это массив
    if (!breadcrumbs || !Array.isArray(breadcrumbs) || breadcrumbs.length === 0) {
      return null;
    }

    // Преобразуем формат из data.breadcrumbs в формат Schema.org
    const itemListElement = breadcrumbs.map((item, index) => {
      // Ваш формат: item.item.name и item.item["@id"]
      // Нужно убедиться, что поля существуют
      const name = item?.item?.name;
      const itemUrl = item?.item?.["@id"];

      // Возвращаем только если есть имя
      if (!name) return null;

      return {
        "@type": "ListItem",
        "position": item.position || index + 1, // используем позицию из данных или индекс
        "name": name,
        // Добавляем item только если есть URL
        ...(itemUrl && { "item": itemUrl })
      };
    }).filter(item => item !== null); // Убираем null элементы

    if (itemListElement.length === 0) {
      return null;
    }

    return {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": itemListElement
    };
  }

  getPageComponent = (template) => {
    switch (template) {
      case 1:
        return <Main data={this.props.data} />
      case 2:
        return <Production data={this.props.data} />
      case 3:
        return <Razdel data={this.props.data} />
      case 4:
        return <Tovar data={this.props.data} />
      case 5:
        return <Docks data={this.props.data} />
      case 6:
        return <Materiali data={this.props.data} />
      case 7:
        return <Material data={this.props.data} />
      case 8:
        return <Kontakti data={this.props.data} />
      case 9:
        return <About data={this.props.data} />
      case 10:
        return <Sotrudnichestvo data={this.props.data} />
      case 11:
        return <Otosole data={this.props.data} />
      default:
        return <Page data={this.props.data} />
    }
  }

  render() {
    const data = this.props?.data || {}
    const breadcrumbJsonLd = this.generateBreadcrumbJsonLd(); // генерируем данные

    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "@id": `https://${data?.helmet.host || 'prompek.com'}#company`,
      "name": "ООО ПКФ «Промпэк»",
      "url": `https://${data?.helmet.host || 'prompek.com'}`,
      "image": `https://${data?.helmet.host || 'prompek.com'}/logo-share.jpg`,
      "telephone": "+7 (8313) 27-54-00",
      "email": "prompek@list.ru",
      "priceRange": "₽₽₽",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Автозаводское шоссе 8 километр",
        "addressLocality": "г. Дзержинск",
        "addressRegion": "Нижегородская область",
        "postalCode": "606008",
        "addressCountry": "RU"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 56.234540,
        "longitude": 43.454277
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday"
          ],
          "opens": "09:00",
          "closes": "18:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Friday",
          "opens": "09:00",
          "closes": "17:00"
        }
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.1",
        "reviewCount": "2"
      },
      "sameAs": [
        "https://zoon.ru/nn/shops/proizvodstvenno-torgovaya_kompaniya_prompek/",
        "https://2gis.ru/dzerzhinsk/firm/2674540559741840"
      ]
    }

    return (
      <>
        <Helmet>
          <title>{( data?.helmet.title || 'Промпэк' ) + ` | Промпэк`}</title>

          <base href={`https://${data?.helmet.host || '89-111-152-59.regru.cloud'}/`} />

          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <meta name="robots" content="all" />

          <meta name="description" content={data?.helmet.description || '89-111-152-59.regru.cloud'} />

          <meta name="yandex-verification" content="62fcd590aeda9963" />
          <meta name="yandex-verification" content="c7cd382eb71d3bba" />

          <meta property="og:type" content="website" />
          <meta property="og:title" content={( data?.helmet.title || 'Промпэк' ) + ` | Промпэк`} />
          <meta property="og:description" content={data?.helmet.description || '89-111-152-59.regru.cloud'} />
          <meta property="og:image" content={`https://${data?.helmet.host || '89-111-152-59.regru.cloud'}/assets/cache_image/logo_0x0_6f7.webp`} />
          <meta property="og:url" content= {`https://${data?.helmet.host || '89-111-152-59.regru.cloud'}`} />

          <link rel="icon" href="/favicon.svg" type="image/x-icon" />

          {/* Вставляем JSON-LD скрипт */}
          {breadcrumbJsonLd && (
            <script type="application/ld+json">
              {JSON.stringify(breadcrumbJsonLd)}
            </script>
          )}
          <script type="application/ld+json">
            {JSON.stringify(jsonLd)}
          </script>

          <script src={`https://api-maps.yandex.ru/2.1/?apikey=${data?.apikey_yandexmap}&lang=ru_RU`}></script>
        </Helmet>
        <div className="min-h-svh flex flex-col items-start justify-between w-full">
          <div className='flex-1 w-full'>
            <Header showMenu={this.handleShow} showWindow={this.handleShowWindow} data={data} />
            {this.getPageComponent(data?.template || 1)}
          </div>
          <div className='w-full'>
            <Footer data={data} showMenu={this.handleShow} showWindow={this.handleShowWindow} />
          </div>
        </div>
        <OffcanvasMenu
          show={this.state.showOffcanvas}
          hide={this.handleHide}
          data={data}
          placement="start"
          backdrop={true}
        />
        <MobileFooter data={data} />
        <Window
          show={this.state.showWindow}
          onHide={this.handleHideWindow}
          data={data}
        />
        <CookieBanner />
      </>
    )
  }
}

export default App
